export const m = {
  login: {
    phoneLength: '11-digit mobile number',
    code: 'Verification code',
    getCode: 'Send',
    login: 'Login',
    serverTips: 'Service provider: SINOAIR',
    serverPhone: 'SINOAIR Customer service hotline',
    errorPhoneformat: 'Incorrect format',
    sucessSend: 'Message sent',
    Updatesuccess: 'Save Success'
  }, home: {
    title: 'Park and Charge',
    goTo: 'Go',
    button: 'Reserve',
    dataNull: 'Currently unavailable',
    ok: 'Confirm ',
    unfulfilledOrder: 'You have outstanding orders. Please try again after you leave',
    notFromH5: 'You have unfinished orders, please go to MyBMW APP/Instant Charging Mini Program to check',
  }, confirmOrder: {
    title: 'Order',
    tip: '*You’ll be rejected if car plate number is incorrect.',
    carPlaceholder: 'Enter license plate number',
    chargeType:"Type",
    chargetInfo1:" BMW Park and Charge",
    chargetInfo2:"BMW Park and Charge-Fast charging",
    inTime: 'Starting from',
    outTime: 'Leaving at',
    duration: 'Parking hours',
    more: 'More',
    choicesTine: 'Frequent Options',
    reservedHours: 'Reserved hours',
    off: '%',
    money: 'Fee',
    hour: 'hours',
    hours:'hour(s)',
    yuan: 'yuan',
    accept: 'I agree to ',
    selectAgreement: '《User Agreement》',
    selectpolicy: '《Data privacy》',
    bottomTop: 'Staff on-site to provide services',
    button: 'Submit order',
    tipTime: "Please reserve entering time",
    CNY: 'CNY',
    ok: 'Confirm',
    cancel: 'Cancel',
    errorcarNo: 'Incorrect license plate format',
    today: 'today',
    tomorrow: 'tomorrow',
    secondDay:'dopodomani',
    threeDay:'three data',
    errorMassage: 'Incorrect time',
    year:'{value} ',
    month:'{value} ',
    day:'{value} ',
    tipsModel1:'Park and Charge Service zone is fully occupied, would you like to reserve random parking space for parking service.',
    tipsModel2:'Please be subject to the actual empty parking space for random parking.',
    modelCancel:'Cancel',
    modelOk:'Reserve',
  }, header: {
    back: "Back",
  }, parkingDuration: {
    title: 'PARK&CHARGE',
    topTips: "Select parking hours",
    hour: 'hour',
    hours: 'hours',
    CNY: "CNY",
    off: '%'
  }, userCenter: {
    title: 'User Center',
    provinceName: 'Unbound',
    vipTitle: 'VIP Membership',
    orderTitle: 'Orders',
    invoicesTitle: 'Getting invoices',
    helpTitle: 'Help',
    logOut: 'Log out ',
    logOutTitle: 'Are you sure you want to log out?',
    ok: 'Confirm',
    cancel: 'Cancel',
  }, personalData: {
    title: 'User Information',
    save: 'Save',
    name: 'Name',
    gender: 'Gender',
    phone: 'Phone',
    licenseNumber: 'Car plate',
    successMeassage: 'Saved',
    male: 'Male',
    female: 'Female',
    placeholderName: 'Enter your name',
    placeholderPhone: 'Enter phone number',
    placeholderCarNo: 'Enter car plate number'
  }, bindingVip: {
    title: 'Bind VIP',
    cardTitle: 'VIP no.',
    save: 'Save',
    binDingSuccess: 'VIP membership bound',
    placeholdeVipNo: 'Enter VIP no.',
  }, changeMobile: {
    title: 'New phone no',
    phoneLength: '11-digit mobile number',
    code: 'Verification code',
    getCode: 'Send ',
    ok: 'CONTINUE',
    cancel: 'CANCEL',
    changeWarning:'This is the fourth time to change the phone number, VIP will be invalid after the successful change',
    errorPhoneformat: 'Incorrect format',
    sucessSend: 'sent',
    Updatesuccess: 'Save',
    successMeassage: 'Save Success',
    newAndOldPhone: 'Same as the previously registered one'
  }, changeCarId: {
    title: 'Change car plate',
    nullCarNumber: 'Enter license plate number',
    carFomat: 'Incorrect license plate format',
    save: 'Save',
    successMeassage: 'Saved',
  }, provinceList: {
    title: 'Select city/province'
  }, vipInfo: {
    title: 'VIP',
    cardNumber: 'VIP card number',
    rights: 'VIP rights',
    language: 'en_US',
  }, orderList: {
    title: 'Orders',
    rightTitle: 'Invoice ',
    reservedInTime: 'Starting from',
    reservedHour: 'Reserved hours',
    reservedMoneyTitle: 'reservation fee',
    reservedMone: 'CNY',
    status1: 'Unpaid',
    status2: 'To enter',
    status3: 'Is parking',
    status3s: 'have paid',
    status4: 'Cancelled',
    status5: 'Unpaid',
    status6: 'Completed',
    status7: 'Overtime Cancellation',
    extraPayStatus: 'Unpaid',
    hours: 'hours',
    pay: 'Pay',
    nullDate: "No order",
    ok: 'confirm',
    uncompletedTips: 'The current order is not completed. Please try again after you leave',
  }, orderDetails: {
    title: 'Order information',
    status4: 'Cancelled',
    status6: 'Completed',
    status7: 'Overtime Cancellation',
    reservedInTime: 'Reserved entering time',
    reservedOutTime: 'Reserved leaving time',
    actualInTime: 'Actual entering time',
    actualOutTime: 'Actual leaving time',
    hoursAndMoeny: 'Reserved parking hours and Fee',
    actualPay: 'Actual paymen',
    hours: 'hours',
    CNY: 'CNY',
    refundAmount: 'Refund amount',
    overpayment: 'Excessive payment',
    orderNumber: 'Order number',
    complaintTitle: 'File a complaint',
    invoicesTitle: 'Getting invoices',
  }, phone: {
    call: 'Call',
    serviceTitle: 'Customer service',
    cancel: 'Cancel'
  }, userHelp: {
    title: 'Help',
    agreementTitle: 'User agreement',
    overTimeRuleClauseTitle:'Rules for overtime',
    rulesTilte: 'Charging rules',
    commonProblemTitle:'常见问题',
    oilicyTitle:'Data privacy',
    notesInboicingTitle: 'Notes on Invoicing',
    serverTitle: 'Customer service',
    language: 'en_US'
  },overTimeRuleClause:{
    title:'Rules for overtime',
    context1:'Fuel vehicles do not need to pay parking fee for overtime. The overtime fee is exempted with no time limit during the trial operation period;',
    context2:'As for new energy vehicles, the overtime fee will settle charging fees based on electricity price and quantity of electricity, any excess payment shall be refunded and any deficiency repaid.',
},
commonProblem:{
  title:'常见问题',
  contextq1:'Q：MINI和劳斯莱斯可以享受服务吗？',
  contexta1:'A：宝马集团的MINI、劳斯莱斯车辆均可以使用该服务，同样使用前需进行线上预约，先约先得。',
  contextq2:'Q：如何进行预约？',
  contexta2:'A：关注“即时充电”微信公众号，选择充电服务后，选择预约停车充电，进入所有场站列表，根据实际情况预约相应场站即可。',
  contextq3:'Q：可以让现场工作人员保存车钥匙吗？',
  contexta3:'A：部分场站提供保存钥匙服务并提供领取凭证，详情可咨询现场工作人员。',
  contextq4:'Q：使用预约停车充电场站该注意些什么？',
  contexta4:'A：请从非ETC通道出入停车场；车辆需停在宝马停车区内；办理出场手续后，15分钟内需驶离停车场，否则，需按照机场标准付费。',
  contextq5:'Q：服务是否可以获得额外折扣？',
  contexta5:'A：BMW与服务运营方共同推出VIP卡，购买宝马新能源的客户可获得更多优惠及权益，详情请咨询经销商。',
  // contextq1:'Q：一共有多少个充电停车位？',
  // contexta1:'A：服务区共有47个车位用于停车，其中10个车位是充电车位。',
  // contextq2:'Q：MINI和劳斯莱斯可以停吗？',
  // contexta2:'A：宝马集团的MINI、劳斯莱斯车辆均可使用该服务，同样使用前需进行线上预约，先约先得。',
  // contextq3:'Q：如何进行预约',
  // contexta3:'A：关注“即时充电”微信公众号，选择充电服务后，选择预约停车充电，进入所有场站列表，选择由华航实际提供服务的北京首都机场T3场站，进行预约。',
  // contextq4:'Q：北京场站预约停车充电服务收费标准是什么？',
  // contexta4:'A：试运营期间，停车免费。充电费用按照实际发生进行收费。',
  // contextq5:'Q：可以让现场工作人员保存车钥匙吗？',
  // contexta5:'A：现场工作人员可以为车主保存钥匙并提供领取凭证。',
  // contextq6:'Q：使用北京预约停车充电场站该注意些什么？',
  // contexta6:'A：请非ETC通道出入停车场；车辆需停在宝马停车区内；从入口处驶入宝马专属停车充电服务区的时间需要在30分钟内，同时从宝马专属停车服务区驶出停车场的时间在30分钟内。',
  // contextq7:'Q：限时免费停车有多久？活动结束后是否还有折扣？',
  // contexta7:'A：预计活动将持续一个月。后续BMW与实际运营方华航共同推出VIP卡，客户可获得更多优惠及权益。',
  // contextq8:'Q：除北京是否还有别的场站提供专属停车充电服务？',
  // contexta8:'A：微信公众号有目前所有开设场站信息，每个场站的运营方式及收费标准不同，详情可关注微信公众号获得更多信息。',
},
invoicing: {
    title: 'Getting invoices',
    list: 'Previous invoices'
  }, invoicesList: {
    title: 'Invoices',
    status6: 'Completed',
    actualInTime: 'Actual entering time',
    actualInHour: 'Actual parking hours',
    hours: 'hours',
    CNY: 'CNY',
    nullDate: "No order",
    language: 'en_US',
    selectAll: 'Select all',
    next: 'Next',
  }, invoicingInfo: {
    title: 'Invoice information',
    topTips: 'Electronic invoice could also be reimbursed as it holds the same validity as paper invoice',
    subtitle1: 'Invoice information',
    subtitle2: 'Receive the invoice via',
    typeTitle: 'Type',
    typeText1: 'Business',
    typeText2: 'Personal/Non-business',
    nameTitle: 'Title',
    risePlaceholder: 'Enter invoice title',
    numberTitle: 'Tax ID',
    numberPlaceholder: 'Enter tax ID',
    contextTitle: 'Item',
    contextText: 'Parking fee',
    contextPlaceholder: 'Parking Fee',
    language: 'en_US',
    moneyTitle: 'Amount',
    emailTilte: 'E-mail',
    tipsTrip: 'For receiving electronic invoice and itinerary',
    emailPlaceholder: 'Please enter email',
    button: 'Submit',
    CNY: 'CNY',
    errorbussinssNumber: "Enter correct tax ID",
    errorEmail: 'Incorrect format',
    tips: 'Please check and confirm your e-mail address. Electronic invoice will be sent to this address.',
    tips2: 'You’ve chosen personal invoice. For reimbursement, choose business. ',
    modalTitle: 'Getting electronic invoice',
    ok: 'Submit',
    cancel: 'Cancel',
  }, complaint: {
    title: 'File a complaint',
    contextpaceholder: 'Please specify your complaint',
    button: 'Submit',
    saveMessage: 'Submit Success'
  }, invoiceCompletion: {
    title: 'E-invoice',
    success: 'Submitted',
    button: 'Previous invoices'
  }, historyInvoicing: {
    title: 'Previous invoices',
    invoiceType: 'Electronic invoice',
    context: 'Parking fee',
    CNY: 'CNY',
    statusStay: 'Not issued',
    statusStop: 'Have issued',
    dataNull: 'No invoice history'
  }, invoiceDetails: {
    title: 'Invoice information',
    sonTitle1: 'Receive the invoice via',
    emailTilte: 'E-mail',
    invoiceTitle: 'Title',
    codeTitle: 'Tax identification number',
    contextTitle: 'Item',
    feeTitle: 'Parking fee',
    amountTilte: 'Amount',
    CNY: 'CNY',
    createDate: 'Apply Time',
    language: 'en_US',
    view: 'View'
  }, invoiceExplain: {
    title: 'Invoice Issuance',
    context1: 'Both parties acknowledges that invoice under this contract is Value-added Tax Invoice, of which the content is the service fee.',
    context2: 'If Party B needs to issue invoices, he/she shall fill in true and effective information for issuance of invoices in relevant pages regarding charging reservation service, and login in [Personal Center]-[Issuance of Invoices], to check the order for issuing invoices, as well as choose the orders for issuing invoices. He/she shall click next step to enter [Details for Issuance of Invoices] and fill in relevant information, and then click the button of [submit] to confirm information for issuance of invoices.',
    context3: 'Upon the request by Party B for submitting relevant information for issuance of invoices, Party A will issue electronical invoices on the spot or send electronical invoices to email address reserved by Party B.',
  }, deductionRuler: {
    title: 'Charge Rules',
    tips: 'Each account is entitled to three unconditional full refunds for post-start cancellations which are cancellations after the orders have already started.',
    orderRuler: 'Refund standards for cancelled orders: ',
    row00: 'Cancellation time',
    row01: 'Refund ratio',
    row02: 'Charging basis',
    row10: '30 minutes before the order starts (including 30 minutes) and above',
    row11: 'Full refund',
    row12: 'No impact is made',
    row20: 'Within 30 minutes before the order starts (excluding 30 minutes)',
    row21: 'Refund 80% of the actual payment',
    row22: 'Due to the impromptu nature of cancellation, at least one hour of parking resource have been wasted, and the expenses should be partially borne. ',
    row30: 'After the order starts',
    row31: 'Refund 50% of the actual payment amount',
    row32: 'Parking resource have been wasted after the order starts. ',
    row40: 'After the order expires',
    row41: 'Not refundable',
    row42: 'Parking resource have been wasted after the order expires. ',
    notesTitle: 'Notes:',
    li1: 'For delays of orders which need to be cancelled due to force majeure such as natural disasters or temporary blockade of the road near the station (within 5 km including 5 km), the fee will be refunded in full upon verification. ',
    li2: 'Each account is entitled to three unconditional full refunds for post-start cancellations which are cancellations after the orders have already started. ',
  }, submitOrder: {
    title: 'Order submitted',
    inTitle: 'Entering',
    tips: 'Please enter on time and wait without parking',
    outTitle: 'Leaving',
    language: 'en_US',
    cancelButton: 'Cancel the order',
    goPay: 'Pay',
    CNY: 'CNY',
    cancelOrderTips: 'Cancel the order?',
    no: 'No',
    yes: 'Yes',
    cancelSuccess: 'Order cancelled',
    tipsTitle:'Tips',
    tipsConetnt:'Please arrive at Service Centre to get the exit voucher after the service is over.'
  }, staySubmitOrder: {
    title: 'Un-entered order',
    inTitle: 'Entering',
    tips: 'Please enter on time and wait without parking',
    outTitle: 'Leaving',
    language: 'en_US',
    cancelButton: 'Cancel the order',
    goPay: 'Fee for reservation',
    CNY: 'CNY',
    no: 'No',
    yes: 'Yes',
    cancelSuccess: 'Order cancelled',
    goRuler: 'Order Cancellation Rules',
    confimButtom:'Confim the order',
    buttonModel:'Confirm'
  }, excessOrder: {
    title: '超额待支付',
    inTime: 'Actual entering time',
    outTime: 'Actual leaving time',
    dateAndMoney: 'Reserved parking hours and Fee',
    excessMoney: '超额支付',
    CNY: 'CNY',
    goPay: 'Pay',
    paySuccess: '支付成功',
  }, overtimeOrder: {
    inTime: 'Actual entering time',
    outTime: 'Actual leaving time',
    dateAndMoney: 'Reserved parking hours and Fee',
    hours: 'hour',
    chargeMoneyTitle:"BMW Park and Charge-Fast charging service fee",
    overTimeMoneyTitle: '超时需支付',
    overTime: '超时',
    CNY: 'CNY',
    goPay: 'Pay',
    paySuccess: '支付成功',
  }, userTreaty: {
    title: 'User Agreement',
    treatyTitle: 'User Agreement for Park & Charge Service',
    agreementNo: 'Agreement Number:',
    context1: 'Dear users: In order to protect your own rights and interests, please read carefully the terms and conditions of this Agreement for a thorough understanding of the rules and scope of the Agreement, as well as the rights, obligations and responsibilities of both parties before using this service. Unless you accept all the terms of this agreement, we will not be able to provide you with this service. By clicking on Agree/Confirm, you are deemed to have fully understood and fully accepted this Agreement and agree to the relevant legal restrictions under this Agreement. If you do not agree to any part of this Agreement or do not understand the terms accurately, please do not proceed.',
    context2: 'Party A: Beijing Huahang Century Culture Communication Co., Ltd.',
    context3: 'Address: 1202, Building 4, Wanda Plaza, No. 93 Jianguo Road, Chaoyang District, Beijing',
    context4: 'Customer Service Number: 400-115-0606',
    context5: 'Party B:',
    context6: 'In view of Party A’s Park & Charge Service, Party A is willing to provide parking and charging reservation service in accordance with the provisions of this Agreement, and Party B is fully aware and informed about this Agreement. Both parties hereby sign this Agreement in accordance with the relevant laws and regulations of the People’s Republic of China.',
    text1: 'I. Definitions:',
    context8: 'Unless otherwise stated in this Agreement, the following terms in this Agreement are defined as follows:',
    context9: '1. Party A: Beijing Huahang Century Culture Communication Co., Ltd., service provider of Park & Charge',
    context10: '2. Party B: Customers who use the Park & Charge service in accordance with this Agreement.',
    context11: '3. Park & Charge service: It is an exclusive vehicle parking & charging service for BMW established by Party A by making online reservations for charging and parking spaces.',
    text2: 'II. Main Items',
    context12: '1. Product introduction: Party B shall, according to the requirements of Party A and the relevant terms of this Agreement, make reservation for parking and charging service at a chosen parking lot on the Park & Charge Service page provided and maintained by Party A at least 30 minutes in advance, select the time and date of arrival, and parking & charging duration, and proceed with payment for the corresponding fee.After receiving the reservation order from Party B, Party A shall reserve the parking and charging space and provide parking and charging service according to Party B’s needs.  ',
    context13: '2. Contract term: The starting and ending time of Party B’s reservation for Park & Charge service, or from the beginning of Party A’s provision of Park & Charge serviceService to the end of the service. ',
    text3: 'III. Process and Method for Park & Charge service',
    context14: '1. On the Park & Charge Service page provided by Party A, Party B selects a reserved parking lot, chooses the arrival time and parking duration, and after confirming the order information, pays the order fee through WeChat according to Party A’s charging standard.',
    context15: '2. After successfully reserving charging and parking space on the Park & Charge Service page, Party B shall arrive at the reserved parking lot on time and present order information to Party A’s staff to initiate the service. Party A’s staff will check and confirm the order information via the software platform, and after confirming order information, he/she will send the actual use information to Party B via the platform. Party B will begin to use the service after receiving the instant message sent by Party A’s staff via the platform.',
    context16: '3. If Party B needs to enter the reservation site in advance and start the service in advance due to personal reasons, in principle, Party B can enter the site as early as 30 minutes before the scheduled entering time. Otherwise, due to the overtime, Party B needs to settle the additional parking fee with the owner of parking lot upon checking-out, in which case Party A should not be held responsible. ',
    context17: '4. Party B shall park and pick up the vehicle according to the actual reserved time for parking and charging. If Party B needs to extend the charging service for his/her own reasons, the extended time will be regarded as overtime, and Party B shall bear the corresponding expenses and fines due to overtime use. Party B shall notify Party A’s staff to finish the service after arriving at the reserved charging and parking lot in case of delay in picking up the car. Party A’s staff will complete the order settlement after confirming the order information via the platform, , as well as send to Party B the additional fees for overtime.After receiving the order information and payment instructions from Party A, Party B will complete the additional fee settlement. The order will be deemed as completed when Party B receives a message of ending of service by Party A’s staff via the platform. ',
    context18: '5. If Party B needs to terminate Park & Charge Service in advance due to its own reasons, Party B can go to the reserved charging and parking lot and notify Party A’s staff to end the service. Party A staff will confirm the order information via the platform and complete the order settlement. The order will be deemed as completed when Party B receives a message of ending of service  sent by Party A’s staff via the platform. Party A has no need to return Party B of the fee for Park & Charge Service which he/she has already paid. ',
    context19: '6. After the completion of the order, Party B needs to leave the parking building zone within 30 minutes after the completion of the order. Under some specific circumstances, for example, upgrade of airport car number identification system, Party A’s staff will issue a parking voucher to Party B. The parking voucher will expire after leaving Park & Charge service parking zone for over 30 minutes, in which case Party A shall not be held responsible for any additional fees charged by the owner of parking lot.',
    context20: '7. In terms of refunds for canceled orders, in principle, the success of reservation and confirmation of payment indicate acknowledgment of the transaction on both parties. But out of consideration for fairness and impartiality, upon the condition that it is determined that the cancellation of the order by Party B has not wasted Party A’s parking resources or constituted serious damage, Party B will enjoy a full refund, and does not bear any corresponding costs incurred due to default if Party B needs to cancel the order and demand for refund. ',
    context21: '8. If the order is cancelled 30 minutes (including 30 minutes) before the official start of the reserved service on the reservation service page provided by Party A, the cancellation will be deemed as a no-fault cancellation, and a full refund will be granted. If the order is cancelled within 30 minutes before the start of the order (excluding 30 minutes) on the reservation service page provided by Party A, the cancellation is deemed as a cancellation for fault, and a cancellation fee will be charged accordingly. In principle, the start of order will be deemed that both parties have acknowledged the transaction and the transaction is not refundable. But to enhance user experience, Party B is still allowed to proceed with a refund request and obtain a partial refund. For the specific refund standards, please refer to the relevant charge and refund instructions of this Agreement. ',
    text4: 'IV. Charge and Refund',
    context22: 'The service in this Agreement mainly includes charging standard for basic reserved charging service and refund standard. Both parties agree to and will settle the fees according to the following terms:',
    context23: '1. Charging standards for basic reserved charging service: The standard for basic reserved charging service is H5.',
    context24: '2. Refund standards for cancelled orders: ',
    text5: 'V. Rights and Obligations of Both Parties',
    context25: '1. Party A has the ownership and the right to use for the reserved parking and charging space, and the ownership of the charging pillar at the parking space. It is obliged to provide Party B with good charging and parking space and functioning charging pillar during the term of the contract.',
    context26: '2. Party B shall ensure that the relevant documents, information and materials provided are true, valid and lawful, and meet the requirements of Party A. If Party A suffers economic losses or legal liabilities due to the false information provided by Party B, Party B shall bear the corresponding losses and legal liabilities. ',
    context27: '3. Party A shall ensure that the charging pillar provided meets national standards. If the quality of the charging pillar provided by Party A causes damage to the vehicle during the charging process, Party A shall bear the main liability for compensation. For the loss beyond insurance coverage, Party B shall collaborate with Party A to pursue the responsibilities of manufacturer of the malfunctioning charging pillar.',
    context28: '4. The Park & Charge Service provided by Party A is a service that provides a parking space and a charging pillar to Party B. Party A shall not bear the responsibility for traffic accidents or other accidents caused by Party B’s inappropriate parking or other personal or third-party reasons for parking within Party A’s space during the term of the contract, including but not limited to scratching, collision and other related vehicle damages. For traffic accidents or other accidents caused by vehicles next to or close to Party B’s vehicle due to inappropriate parking on the part of Party B, including, but not limited to scratching, collision and other related vehicle damages, Party B shall bear the corresponding legal responsibility. For traffic accidents or other accidents caused to Party B’s vehicle, including, but not limited to scratching, collision and other related vehicle damages when Party B vehicle is parked in the parking space provided by Party A, Party A, as the provider of the parking space and charging pillar, is obligated to assist Party B in finding the culprit. ',
    context29: '5. During the term of this contract, in the event of an accident (including but not limited to traffic accidents, casualties and death, damage to the vehicle, damage to the charging pillar, damage to the building, etc.), both parties shall promptly report the case to the police, and bear corresponding responsibility according to the liability opinion issued by statutory authorities.',
    context30: '6. If Party A’s parking lot or charging pillar is damaged due to improper operation of Party B, Party A has the right to request Party B to make compensation for the loss according to the actual damaged value.',
    text6: 'VI. Invoice Issuance',
    context31: '1.Both parties acknowledges that invoice under this contract is Value-added Tax Invoice, of which the content is the service fee.',
    context32: '2.If Party B needs to issue invoices, he/she shall fill in true and effective information for issuance of invoices in relevant pages regarding charging reservation service, and login in [Personal Center]-[Issuance of Invoices], to check the order for issuing invoices, as well as choose the orders for issuing invoices. He/she shall click next step to enter [Details for Issuance of Invoices] and fill in relevant information, and then click the button of [submit] to confirm information for issuance of invoices.',
    context33: '3.Upon the request by Party B for submitting relevant information for issuance of invoices, Party A will issue electronical invoices on the spot or send electronical invoices to email address reserved by Party B.',
    text7: 'VII. Amendment and Termination of this Agreement',
    context34: '1. Both parties confirm that compliance to relevant laws and regulations is a prerequisite to the signing, entry into force and fulfillment of this Agreement. If any one or more terms in the Agreements are found to be in violation with the applicable laws by the judiciary authorities or for any other reasons deemed invalid, the invalidity does not affect the validity of the other terms of this Agreement.',
    context35: '2. Party B agrees that Party A has the right to adjust or end this Agreement and relevant rules in this Agreement in accordance with national laws and regulations, market changes, etc.',
    context36: '3. The adjusted or revised agreement and the relevant rules will be published on Party A’s platforms (including but not limited to official website announcements, private messages, mobile platforms, etc.) and will be effective immediately without further notice to Party B. If Party B does not accept the changes, he/she shall immediately contact Party A to end the service; If Party B continues to use the services, Party B is deemed to have accepted the changes, and is subject to the amended agreement and constraints of relevant rules.',
    context37: '4. Any modification or supplementation to this Agreement shall be made in the form of electronic text on Party A’s relevant platforms.',
    text8: 'VIII. Settlement of Disputes',
    context38: '1. The establishment, entry into force, fulfillment, interpretation and dispute resolution of this Agreement shall be governed by the laws of the People’s Republic of China.',
    context39: '2. All disputes concerning this Agreement shall be settled by both parties in a spirit of mutual benefit. If the negotiation fails, it shall be submitted to Chaoyang District Court for settlement.',
    text9: 'IX. Entry-into-force Condition',
    context40: '1. This Agreement is generated in electronic text form.',
    context41: '2. This agreement enters into force: Party B, according to Party A’s request, clicks on “WeChat Payment” or other alternatives for reservation and payment on the relevant web page (subject to the actual page display), which will be deemed that Party A and Party B have made an agreement and agree to accept all the terms and conditions in this Agreement and its appendices, as well as all other provisions of Party A regarding this Agreement.',
  }, addressList: {
    title: 'Reserve parking lot',
    placeholderCity: 'Search City',
    currentCity: 'Current City',
    cancel: 'Cancel',
    noResult: 'No search results available'
  }, dataTime: {
    hours: 'hours',
    hour:'hour(s)',
    minute: 'minute'
  }, time: {
    inTime: 'Actual entering time',
    duration: 'Reserved hours',
    surplusTime: 'Rmaining Time',
    refreshTime: 'Refresh Time',
    refreshSuccess: 'Refresh the success',
    tips: 'Tips: do not enter the ETC exit channel.',
    overtimeFee: 'Overtime fee',
    CNY: 'CNY',
    timePeriod: 'Over Time',
    orderAccomplish: 'The order has been completed.',
    overtime: 'Overtime'
  },oilicyPage:{
    title:'Data privacy',
    context1:'Welcome to using the services available through the Platform!  When you visit the Platform and use our services, you trust us with your personal information.  We recognize that we must act responsibly and thus have created this Privacy Agreement to demonstrate our firm commitment to your privacy.  It is the general policy of SinoAir to value and protect users’ privacy and personal information, and to this end, SinoAir will take strict measures for the protection of personal data.',
    context2:'To enable the service appointment relating to vehicle parking and charging and other services available through the Platform as requested by you, you agree that the information associated with your use of the Service (as defined below) may be shared with and used by SinoAir as the operator of this Platform, BMW Brilliance Automotive Ltd. as the intellectual property owner of the Platform, and BMW China Automotive Trading Ltd. and its authorized dealers and affiliates, including but not limited to BMW AG, BMW China Services Ltd., BMW Automotive Finance (China) Co., Ltd. and Herald International Financial Leasing Co., Ltd. (collectively “BMW”), pursuant to this Privacy Policy. ',
    context3:'This Privacy Policy does not apply to any third party programs with which you may choose to share information through this Platform.  Neither Operator nor BMW is responsible for the privacy practices or the content of these third party programs.',
    context4:'When you register or log in for the Service, schedule a parking service appointment or pay for the Service, SinoAir may collect your mobile phone number, license plate number, location data, transaction information and other personal information that you choose to provide to SinoAir, including name and gender.  You have the right to opt out of providing SinoAirsuch information.  Please note that if you decide not to provide the requested mobile phone number, license plate number, location data or transaction information, you will be unable to utilize the parking and charging service appointment or valet parking service associates with that information.',
    context5:'Your personal information collected in connection with the local operations of SinoAirwill be stored within the People’s Republic of China.  SinoAironly retains your personal information for as long as necessary to provide you with the Service, and does not knowingly share or transfer your personal information to any other parties outside of BMW unless you have given consent for us to do so.',
    context6:'Please understand that in accordance with applicable laws, regulations and national standards, we may share, transfer and disclose the relevant personal information without the prior permission by data subject, if such sharing, transfer or disclosure of personal information is:',
    li1:'Directly related to national security or national defense;',
    li2:'Directly related to public security, public health or significant public interest;',
    li3:'Directly related to the investigation, prosecution, trial or enforcement of any crime; or',
    li4:'To protect the life, property or other major legitimate rights and interests of data subject or of other individual, while it is difficult to obtain the consent of the subject of such personal information.'
  }
}
